(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('ProfessionalAreaSearch', ProfessionalAreaSearch);

    ProfessionalAreaSearch.$inject = ['$resource'];

    function ProfessionalAreaSearch($resource) {
        var resourceUrl =  'api/_search/professional-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
